function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React from 'react';
import UserPaymentPage from './payment/user-payment';
import Tabs from 'antd/es/tabs';
import { useSearchParams } from 'react-router-dom';
import SurveyList from './survey/survey-list';
import UserStatisticPage from './statistic/user-statstic-page';
import RankRequestPendingPage from './rank-request-pending/page';
export default function UserListPage() {
    const _useSearchParams = useSearchParams(), _useSearchParams2 = _slicedToArray(_useSearchParams, 2), searchParams = _useSearchParams2[0], setSearchParams = _useSearchParams2[1];
    const activeTab = searchParams.get('tab') || 'users';
    const handleChange = key => {
        setSearchParams({
            tab: key
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-hidden bg-[#f5f5f5] text-[40px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full px-6 py-2"
    }, /*#__PURE__*/ React.createElement(Tabs, {
        activeKey: activeTab,
        onChange: handleChange,
        items: [{
                key: 'users',
                label: 'ユーザー一覧',
                children: /*#__PURE__*/ React.createElement(UserPaymentPage, null)
            }, {
                key: 'rank_requests',
                label: 'ランク申請一覧',
                children: /*#__PURE__*/ React.createElement(RankRequestPendingPage, null)
            }, {
                key: 'survey',
                label: 'アンケート一覧',
                children: /*#__PURE__*/ React.createElement(SurveyList, null)
            }, {
                key: 'statistic',
                label: 'ユーザーの集計',
                // children: <StatisticsPage />,
                children: /*#__PURE__*/ React.createElement(UserStatisticPage, null)
            }]
    })));
}
